"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cReportAbuseSearchFiltersSchema = exports.ReportAbuseActionTaken = exports.ReportAbuseStatus = exports.ReportAbuseCategory = exports.ReportAbuseType = void 0;
var zod_1 = require("zod");
var ReportAbuseType;
(function (ReportAbuseType) {
    ReportAbuseType[ReportAbuseType["pm"] = 1] = "pm";
    ReportAbuseType[ReportAbuseType["discussion"] = 2] = "discussion";
    ReportAbuseType[ReportAbuseType["profile"] = 3] = "profile";
    ReportAbuseType[ReportAbuseType["entity"] = 4] = "entity";
    ReportAbuseType[ReportAbuseType["file"] = 5] = "file";
    ReportAbuseType[ReportAbuseType["discussionMessage"] = 6] = "discussionMessage";
    ReportAbuseType[ReportAbuseType["headlessPost"] = 7] = "headlessPost";
    ReportAbuseType[ReportAbuseType["headlessComment"] = 8] = "headlessComment";
})(ReportAbuseType || (exports.ReportAbuseType = ReportAbuseType = {}));
var ReportAbuseCategory;
(function (ReportAbuseCategory) {
    ReportAbuseCategory["spam"] = "spam";
    ReportAbuseCategory["abusive"] = "abusive";
    ReportAbuseCategory["other"] = "other";
})(ReportAbuseCategory || (exports.ReportAbuseCategory = ReportAbuseCategory = {}));
var ReportAbuseStatus;
(function (ReportAbuseStatus) {
    ReportAbuseStatus["open"] = "open";
    ReportAbuseStatus["reviewing"] = "reviewing";
    ReportAbuseStatus["ignored"] = "ignored";
    ReportAbuseStatus["closed"] = "closed";
})(ReportAbuseStatus || (exports.ReportAbuseStatus = ReportAbuseStatus = {}));
var ReportAbuseActionTaken;
(function (ReportAbuseActionTaken) {
    ReportAbuseActionTaken["nothing"] = "nothing";
    ReportAbuseActionTaken["deleted"] = "deleted";
    ReportAbuseActionTaken["allowed"] = "allowed";
})(ReportAbuseActionTaken || (exports.ReportAbuseActionTaken = ReportAbuseActionTaken = {}));
exports.cReportAbuseSearchFiltersSchema = zod_1.z.strictObject({
    id: zod_1.z.optional(zod_1.z.number().or(zod_1.z.null())),
    reportedId: zod_1.z.optional(zod_1.z.number().or(zod_1.z.string()).or(zod_1.z.null())),
    type: zod_1.z.optional(zod_1.z.nativeEnum(ReportAbuseType).or(zod_1.z.null())),
    status: zod_1.z.optional(zod_1.z.nativeEnum(ReportAbuseStatus).or(zod_1.z.null()).or(zod_1.z.null())),
    category: zod_1.z.optional(zod_1.z.nativeEnum(ReportAbuseCategory).or(zod_1.z.null())),
    accountIdReported: zod_1.z.optional(zod_1.z.number().or(zod_1.z.string()).or(zod_1.z.null())),
    accountIdCreated: zod_1.z.optional(zod_1.z.number().or(zod_1.z.string()).or(zod_1.z.null()))
});
